import lazyLoading from './lazyLoading'
import Global from '../../../services/globalservice'

export default {
  name: 'Allowance',
  meta: {
    icon: 'fa-gift',
    expanded: false,
    roles: [Global.ROLE.ADMIN]
  },

  children: [
    {
      name: 'View List',
      path: '/allowance/AllowanceViewList',
      meta: {
        roles: [Global.ROLE.ADMIN]
      },
      component: lazyLoading('allowance/AllowanceViewList')
    },
    {
      name: 'Add New',
      path: '/allowance/AllowanceAddNew',
      meta: {
        roles: [Global.ROLE.ADMIN]
      },
      component: lazyLoading('allowance/AllowanceAddNew')
    },
    {
      name: 'View Draft',
      path: '/allowance/AllowanceViewDraft',
      meta: {
        roles: [Global.ROLE.ADMIN]
      },
      component: lazyLoading('allowance/AllowanceViewDraft')
    },
    {
      name: 'Setting',
      path: '/allowance/AllowanceSetting',
      meta: {
        roles: [Global.ROLE.ADMIN]
      },
      component: lazyLoading('allowance/AllowanceSetting')
    }
  ]
}


// WEBPACK FOOTER //
// ./client/store/modules/menu/allowance.js